// 浜歩き: after each night the crabs walk the beach at dawn and pick up what
// the tide left. Free randomness only (no paid draws), and fixed per night so
// a beach cannot be rerolled.
import { rand, hashText } from '../sim/rand.js';
import { SHELLS } from '../sim/shells.js';
import { DRIFT } from './profile.js';

const RARITY_WEIGHT = [60, 30, 9, 1];

export function beachFinds({ date, mode, n = 0, tide, rules, saved, total, lucky = false, moonRoad = false }) {
  const r = rand(hashText(`beach:${date}:${mode}:${n}`));
  const big = tide === 'oshio' || tide === 'nakashio';
  let count = 1 + Math.floor(saved / 4) + (big ? 1 : 0) + (lucky ? 1 : 0) + (moonRoad ? 1 : 0);
  if (mode !== 'daily') count = Math.max(1, Math.ceil(count / 2));
  const finds = [];
  for (let k = 0; k < count; k++) {
    const roll = r.below(100);
    if (roll < 42) finds.push({ type: 'drift', id: DRIFT[r.below(DRIFT.length)], n: 1 + r.below(2) });
    else if (roll < 66) finds.push({ type: 'pearl', n: 1 + (saved === total ? 1 : 0) });
    else finds.push({ type: 'shell', id: pickShell(r, rules, big, moonRoad) });
  }
  return finds;
}

// Shells that suit tonight's rules wash up more often; big tides and the moon
// road tilt the odds toward rarer ones.
function pickShell(r, rules, big, moonRoad) {
  const ids = Object.keys(SHELLS);
  const weight = id => {
    const s = SHELLS[id];
    let w = RARITY_WEIGHT[s.rarity] * (s.rarity >= 2 && (big || moonRoad) ? 2 : 1);
    if (s.tags.some(t => rules.includes(t))) w *= 3;
    return w;
  };
  const total = ids.reduce((n, id) => n + weight(id), 0);
  let x = r.below(total);
  for (const id of ids) { x -= weight(id); if (x < 0) return id; }
  return ids[0];
}
